import { type IStateResult, UsaStates } from 'usa-states'

export const usaStates = new UsaStates({
  includeTerritories: true,
  contiguousOnly: false,
  exclude: [],
  ignoreCharacter: '$',
}).states

export const getUSARegionOptions = usaStates.map((state: IStateResult) => ({
  label: state.name,
  value: state.abbreviation,
}))

export const getUSARegionOptionsIncludingAll = [
  { label: 'All', value: 'all' },
  ...getUSARegionOptions,
]

export const getUSARegionLabels = usaStates.reduce<Record<string, string>>(
  (acc, state) => {
    acc[state.abbreviation] = state.name
    return acc
  },
  { all: 'All' },
)
